import "./index.css";
import { useBreakpoints } from "@/hooks/useBreakpoints";
import { Heading, Skeleton } from "@/ui-kit";
import type { IBreadcrumbItem } from "./PageTitleProvider";

type IProps = {
  items: IBreadcrumbItem[];
};

export const Breadcrumbs = ({ items }: IProps) => {
  const { isMobile } = useBreakpoints();
  const allLoading = items.every((item) => item.loading);

  if (allLoading) {
    return (
      <div className="page-header__breadcrumbs">
        <Skeleton width="12.5rem" height="2.625rem" />
      </div>
    );
  }

  const filteredItems = isMobile
    ? ([items.at(-1)] as IBreadcrumbItem[])
    : items;

  const itemsJSX = filteredItems.map((item, index) => {
    const isLast = index === filteredItems.length - 1;
    return (
      <div className="page-header__breadcrumbs-item" key={item.id}>
        {item.loading ? (
          <Skeleton width="12.5rem" height="2.625rem" />
        ) : (
          <Heading
            level={isMobile ? 4 : 3}
            tone={isLast ? "default" : "muted"}
            as="h3"
          >
            {item.title}
          </Heading>
        )}
        {!isLast && (
          <Heading level={3} tone="muted">
            /
          </Heading>
        )}
      </div>
    );
  });

  return <div className="page-header__breadcrumbs">{itemsJSX}</div>;
};
